module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('heading', {
    attrs: {
      "text": _vm.report.title,
      "level": 2,
      "font": "oswald",
      "color": "silver"
    }
  }), _vm._v(" "), (_vm.report.date) ? _c('div', {
    staticClass: "credits"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('liveReports.credits')) + " " + _vm._s(_vm.report.author))]), _c('br'), _vm._v("\n    " + _vm._s(_vm.$d(new Date(_vm.report.date), 'short')) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.report.content), function(txt) {
    return _c('div', {
      staticClass: "content"
    }, [_c('h3', [_vm._v(_vm._s(txt.band))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(txt.report)
      }
    })])
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b781d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/LiveReport.vue
// module id = 266
// module chunks = 0